import cookieClass from "./cookieClass";
import axios from 'axios';

export default class userCookie extends cookieClass {

  private admin = false;

  public userId = null;

  public premium = false;

  constructor(name: string) {
    super(name)
  }

  public async setValues(user) {
    if (user) {
      if (this.value)
        this.userId = this.value.user_id
      await this.setAdmin()
    }
  }

  /**
   * En tancar la sessió, també oblida l'estat calculat de l'usuari (no es recarrega la pàgina)
   */
  public remove(): void {
    super.remove();
    this.admin = false;
    this.userId = null;
    this.premium = false;
    if ('premium_type' in this) (this as any).premium_type = null;
  }

  public isAdmin() {
    return this.admin;
  }

  public isEditor() {
    return this.value && this.value.role && this.value.role === 'editorX';
  }

  public async setAdmin() {
    if (this.value) {
      const {data} = await axios.get("/admin/" + this.value.user_id);
      this.admin = data;
    }
  }


}
